module.exports = __webpack_public_path__ + "img/center22.60944f99.png";